<div class="ml-auto col-auto">
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/edit']">
    <nb-icon icon="edit-outline" pack="eva"></nb-icon> Edit
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/medialib']">
    <nb-icon icon="film-outline" pack="eva"></nb-icon> Media lib
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/edit-roles']" *ngIf="game?.hasRoles">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Roles
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/edit-characters']" *ngIf="game?.hasCharacters">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Characters
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="game?.hasObjects" [routerLink]="['/pages/game/'+game?.id+'/edit-objects']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Objects
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="game?.hasResources" [routerLink]="['/pages/game/'+game?.id+'/edit-resources']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Resources
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="game?.hasBuildings" [routerLink]="['/pages/game/'+game?.id+'/edit-buildings']">
    <nb-icon icon="edit-2-outline" pack="eva"></nb-icon> Edit Buildings
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/teams']">
    <nb-icon icon="people-outline" pack="eva"></nb-icon> Teams
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/groups']">
    <nb-icon icon="people-outline" pack="eva"></nb-icon> Groups
  </a>
  <!--<button nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/all-teams']">
    <nb-icon icon="people-outline"></nb-icon>All-teams
  </button>-->
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/edit-missions']">
    <nb-icon icon="list-outline" pack="eva"></nb-icon> Missions
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/diagram']">
    <nb-icon icon="share-outline" pack="eva"></nb-icon> Diagram
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/game-builder']">
    <nb-icon icon="map-outline" pack="eva"></nb-icon> Builder
  </a>
  <!--<a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/auto-deploy']">
    <nb-icon icon="bulb-outline" pack="eva"></nb-icon> Deployer
  </a>-->
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/overview']">
    <nb-icon icon="eye-outline" pack="eva"></nb-icon> Preview
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/player']">
    <nb-icon icon="play-circle-outline" pack="eva"></nb-icon> Play
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" [routerLink]="['/pages/game/'+game?.id+'/gallery']">
    <nb-icon icon="image-outline" pack="eva"></nb-icon> Gallery
  </a>
  <a nbButton size="tiny" status="basic" class="btn ml-3" (click)="window.open('/pages/city/'+game?.cityId+'/poi/import');" *ngIf="game?.cityId">
    <nb-icon icon="plus-outline"></nb-icon>Poi manager
  </a>
</div>
